import { KEYCHRONTYPINGSHOOTER_brandVariables } from "./brands/KEYCHRON-typing-shooter.brandvariables";
import { KEYCHRONTIMETRAIL_brandVariables } from "./brands/KEYCHRON-time-trail.brandvariables";
import { KEYCHRONVERTICAL_brandVariables } from "./brands/KEYCHRON-vertical.brandvariables";
import { SAMSUNG_brandVariables } from "./brands/SAMSUNG-racing.brandvariables";
import { SAMSUNGBASE_brandVariables } from "./brands/SAMSUNG.brandvariables";
import { LOGITECHRD_brandVariables } from "./brands/LOGITECHRD.brandvariables";
import { ELGIGANTEN_brandVariables } from "./brands/ELGIGANTEN.brandvariables";
import { LOGITECH_brandVariables } from "./brands/LOGITECH.brandvariables";
import { LEGO_BTP_brandVariables } from "./brands/LEGO-BTP.brandvariables";
// import { KEYCHRON_brandVariables } from "./brands/KEYCHRON.brandvariables";
import { TCLTT_brandVariables } from "./brands/TCLTT.brandvariables";
import { LEGO_brandVariables } from "./brands/LEGO.brandvariables";
import { JBL_brandVariables } from "./brands/JBL.brandvariables";
import { brandVariablesTypes } from "./brandVariables.types";

const brandInfo = {
  legoxf1: LEGO_brandVariables,
  legobtp: LEGO_BTP_brandVariables,
  elgiganten: ELGIGANTEN_brandVariables,
  logitech: LOGITECH_brandVariables,
  racedays: LOGITECHRD_brandVariables,

  "tcl-tt": TCLTT_brandVariables,
  "jbl-tt": JBL_brandVariables,
  // "keychron-tt": KEYCHRON_brandVariables,
  "keychron-ttv": KEYCHRONVERTICAL_brandVariables,
  "keychron-ts": KEYCHRONTYPINGSHOOTER_brandVariables,
  "keychron-time-trial": KEYCHRONTIMETRAIL_brandVariables,
  "samsung-racing": SAMSUNG_brandVariables,
  samsung: SAMSUNGBASE_brandVariables,
  list: KEYCHRONTYPINGSHOOTER_brandVariables,
};

const basePath = window.location.pathname.split("/")[1]; // "racedays"
// Cast: brand files use string-literal values not narrowed via `as const` or
// `satisfies`. Tightening at the call site keeps consumers fully typed.
export const brand = brandInfo[
  basePath as keyof typeof brandInfo
] as brandVariablesTypes;
